import { ACOMBAGO_ORIGIN } from '../../env';

export function getAcombagoOrigins(): string[] {
    if (!ACOMBAGO_ORIGIN) return [];
    return ACOMBAGO_ORIGIN.split(',').map((s) => s.trim()).filter(Boolean);
}
